'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _WMToolTip = require('../WMToolTip');

var _WMToolTip2 = _interopRequireDefault(_WMToolTip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WMStatefulToolTip = function (_Component) {
	_inherits(WMStatefulToolTip, _Component);

	function WMStatefulToolTip(props) {
		_classCallCheck(this, WMStatefulToolTip);

		var _this = _possibleConstructorReturn(this, (WMStatefulToolTip.__proto__ || Object.getPrototypeOf(WMStatefulToolTip)).call(this, props));

		_this.handleMouseEnter = function (event) {
			return _this.setState({
				anchorEl: event.currentTarget,
				isOpen: true
			});
		};

		_this.handleMouseLeave = function () {
			return _this.setState({ isOpen: false });
		};

		_this.state = {
			anchorEl: null,
			isOpen: false
		};
		return _this;
	}

	_createClass(WMStatefulToolTip, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    anchorOrigin = _props.anchorOrigin,
			    canAutoPosition = _props.canAutoPosition,
			    children = _props.children,
			    id = _props.id,
			    targetOrigin = _props.targetOrigin,
			    tooltipContent = _props.tooltipContent,
			    zDepth = _props.zDepth,
			    style = _props.style;


			return _react2.default.createElement(
				'span',
				null,
				_react2.default.createElement(
					'span',
					{
						className: id && 'tooltip_origin__' + id,
						onMouseEnter: this.handleMouseEnter,
						onMouseLeave: this.handleMouseLeave
					},
					children
				),
				_react2.default.createElement(
					_WMToolTip2.default,
					{
						style: style || null,
						anchorEl: this.state.anchorEl,
						anchorOrigin: anchorOrigin,
						canAutoPosition: canAutoPosition,
						open: this.state.isOpen,
						targetOrigin: targetOrigin,
						zDepth: zDepth
					},
					tooltipContent
				)
			);
		}
	}]);

	return WMStatefulToolTip;
}(_react.Component);

exports.default = WMStatefulToolTip;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMStatefulToolTip/index.js